export type MeSombEnvironment = 'live' | 'sandbox';

const ENVIRONMENT_STORAGE_KEY = 'environment';
const TAB_ENVIRONMENT_KEY = 'mesomb:tab-environment';
let activeEnvironment: MeSombEnvironment | undefined;

export const getEnvironment = (): MeSombEnvironment => {
  if (activeEnvironment) return activeEnvironment;
  let stored: string | null = null;
  try { stored = sessionStorage.getItem(TAB_ENVIRONMENT_KEY); } catch { /* Use the last-used preference. */ }
  if (stored !== 'live' && stored !== 'sandbox') {
    try { stored = localStorage.getItem(ENVIRONMENT_STORAGE_KEY); } catch { /* Default to live. */ }
  }
  activeEnvironment = stored === 'sandbox' ? 'sandbox' : 'live';
  try { sessionStorage.setItem(TAB_ENVIRONMENT_KEY, activeEnvironment); } catch { /* Keep the tab pinned in memory. */ }
  return activeEnvironment;
};

export const setEnvironment = (environment: MeSombEnvironment) => {
  activeEnvironment = environment;
  try { sessionStorage.setItem(TAB_ENVIRONMENT_KEY, environment); } catch { /* Keep the tab pinned in memory. */ }
  try { localStorage.setItem(ENVIRONMENT_STORAGE_KEY, environment); } catch { /* Storage may be unavailable. */ }
};

/** Only a confirmed signup may override a previously saved environment. */
export const initializeSignupEnvironment = (isNewAccount: boolean) => {
  if (isNewAccount) setEnvironment('sandbox');
};

export const environmentPersistKey = (slice: string) =>
  `mesomb:${getEnvironment()}:${slice}`;

export const commonPersistKey = (slice: string) => `mesomb:common:${slice}`;
